import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EntityPath, Protocol, url } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { IUserPhoto, TUploadFile } from '@shared/components/user-photo/data-access/entities/user-photo.interface';
import { eStorageFolder } from '../entities/user-photo.enum';

@Injectable({
  providedIn: 'root'
})
export class UserPhotosService {
  private http = inject(HttpClient);

  public getUserPhotosById(id: string): Observable<IUserPhoto[]> {
    return this.http.get<IUserPhoto[]>(url(Protocol.https, EntityPath.file_group_service, '/UserPhotos'), {
      params: {
        groupId: id,
        flag: 2
      },
      withCredentials: true
    });
  }

  public postUserPhoto(userPhoto: Partial<IUserPhoto>): Observable<IUserPhoto> {
    return this.http.post<IUserPhoto>(url(Protocol.https, EntityPath.file_group_service, '/UserPhotos'), userPhoto, {
      withCredentials: true
    });
  }

  public putUserPhoto(userPhoto: IUserPhoto): Observable<IUserPhoto> {
    return this.http.put<IUserPhoto>(url(Protocol.https, EntityPath.file_group_service, '/UserPhotos'), userPhoto, {
      withCredentials: true
    });
   }

  public setFlagAsyncToTreino(fileId: string): Observable<void> {
    return this.http.put<void>(url(Protocol.https, EntityPath.file_group_service, '/UserPhotos/SetFlagAsync'), null, {
      params: {
        fileId,
        flag: 2
      },
      withCredentials: true
    });
  }

  public uploadFile(file: File, folder: eStorageFolder): Observable<TUploadFile> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post<TUploadFile>(
      url(Protocol.https, EntityPath.storage_service, '/FileUpload/Upload'),
      formData,
      {
        params: { folder },
        withCredentials: true,
      }
    );
  }
}
